import { useToast } from "@/components/ui/toastercustom";
import { IRegisterData } from "@/features/authentication/interfaces/IAuth";
import { forgotPassword } from "@/features/authentication/services/auth.services";
import useProfileStore from "@/stores/profile";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { FormForgotPasswordValues } from "@/features/authentication/components/formForgotPassword/FormForgotPassword";

const useForgotPassword = () => {
  const { toast } = useToast();

  // State
  const [isDisabledSubmit, setIsDisabledSubmit] = useState<boolean>(false);

  // USE MUTATION ---------------------------------------------------------
  /**
   * @description This hook handle forgot password form
   */
  const { mutateAsync } = useMutation({
    mutationKey: ["forgotpassword"],
    mutationFn: async (data: Pick<IRegisterData, "email">) => {
      // Call forgot password api
      const result = await forgotPassword({
        email: data.email,
      });

      if (!result?.status) {
        toast({
          title: "Error",
          type: "error",
          text: result?.message ?? "Try again.",
        });
      } else {
        toast({
          title: "Success",
          type: "success",
          text: result?.message ?? "Success please check email.",
        });
        useProfileStore.setState({
          token: result?.token,
        });
      }
    },
    onError: (error) => {
      console.error(error);
      setIsDisabledSubmit(false);
    },
    onSuccess: () => {
      setIsDisabledSubmit(false);
    },
  });

  // -----------------------------------------------------------------------

  /**
   * @description Handle submit form
   */
  const onSubmit = (data: FormForgotPasswordValues) => {
    setIsDisabledSubmit(true);
    mutateAsync(data);
  };

  // Return the function
  return {
    onSubmit,
    isDisabledSubmit,
  };
};

export default useForgotPassword;
